import { MerchantInFoModel } from "./MerchantInFoModel";

export class SelectedMerchantModel extends MerchantInFoModel {
  merchantType!: number;
  taxStatus!: number;
  createDateTime!: Date;
  expireDateTime!: Date;
  logoUrl!: string;
  stampUrl!: string;
  isAccountingFirm!: boolean;
  joinMerchantDateTime!: Date;
  code!: string;
  packageName!: string;
  isVat!: boolean;
  isActivePayroll!: boolean;
  isLockPeriod!: boolean;
  lockPeriodEndDate!: Date;
  package!: number;
  merchantPackageRight!: MerchantPackageRightModel;
  role!: UserRoleInfoModel;
}
export class UserRoleInfoModel {
  authorityRole!: number;
  role!: number;
  manageUser!: number;
  manageFinance!: boolean;
  isSuperUser!: boolean;
  isUsePayroll!: boolean;
  isUsePeakBoard!: boolean;
  manageProduct!: boolean;
  isSeeSelfDocuments!: boolean;
  manageFinanceAndJournals!: number;
  manageAsset!: boolean;
  manageContact!: number;
  isViewReport!: boolean;
}
export class MerchantPackageRightModel {
  totalUserId!: number;
  application!: MerchantPackageRightApplicationModel;
  account!: MerchantPackageRightPeakAccountApplicationModel;
  tax!: MerchantPackageRightPeakTaxApplicationModel;
  asset!: MerchantPackageRightPeakAssetApplicationModel;
}
export class MerchantPackageRightApplicationModel {
  peakAccount!: boolean;
  oldPeakAccount!: boolean;
  peakPayroll!: boolean;
  peakAsset!: boolean;
  peakBoard!: boolean;
  peakTax!: boolean;
  peakLineConnect!: boolean;
  peakMobile!: boolean;
  peakDocument!: boolean;
}
export class MerchantPackageRightPeakAccountApplicationModel {
  totalDocumentPerMonth!: number;
  export!: boolean;
  importProduct!: boolean;
  importContact!: boolean;
  importTransaction!: boolean;
  partailPayment!: boolean;
  fileVault!: boolean;
  revenue!: MerchantPackageRightPeakAccountApplicationRevenueModel;
  expense!: MerchantPackageRightPeakAccountApplicationExpenseModel;
  finance!: MerchantPackageRightPeakAccountApplicationFinanceModel;
  account!: MerchantPackageRightPeakAccountApplicationAccountsModel;
  setting!: MerchantPackageRightPeakAccountApplicationSettingModel;
}
export class MerchantPackageRightPeakAccountApplicationRevenueModel {
  quotation!: boolean;
  invoice!: boolean;
  invoiceAsset!: boolean;
  receipt!: boolean;
  receiptAsset!: boolean;
  taxInvoice!: boolean;
  creditNote!: boolean;
  billingNote!: boolean;
  debitNote!: boolean;
  recurringInvoice!: boolean;
  recurringReceipt!: boolean;
}
export class MerchantPackageRightPeakAccountApplicationExpenseModel {
  purchaseOrder!: boolean;
  purchaseOrderAsset!: boolean;
  expense!: boolean;
  purchaseAsset!: boolean;
  purchaseTaxInvoice!: boolean;
  receivedCreditNote!: boolean;
  receivedDebitNote!: boolean;
  combinePaymentNote!: boolean;
  recurringExpense!: boolean;
}
export class MerchantPackageRightPeakAccountApplicationFinanceModel {
  addFinance!: boolean;
  reconcile!: boolean;
  statement!: boolean;
}
export class MerchantPackageRightPeakAccountApplicationAccountsModel {
  addAccount!: boolean;
  actionJournal!: boolean;
}
export class MerchantPackageRightPeakAccountApplicationSettingModel {
  user!: MerchantPackageRightPeakAccountApplicationUserSettingModel;
  document!: MerchantPackageRightPeakAccountApplicationDocumentSettingModel;
  accountingPolicy!: MerchantPackageRightPeakAccountApplicationAccountingPolicySettingModel;
  applicationConnect!: boolean;
}
export class MerchantPackageRightPeakAccountApplicationUserSettingModel {
  userRoleContact!: boolean;
}
export class MerchantPackageRightPeakAccountApplicationDocumentSettingModel {
  cassification!: boolean;
  redirectLinkReport!: boolean;
  taxInvoice!: boolean;
  journal!: boolean;
}
export class MerchantPackageRightPeakAccountApplicationAccountingPolicySettingModel {
  summaryReport!: boolean;
  creditLimit!: boolean;
  purchaseOrderStatusUpdate!: boolean;
}
export class MerchantPackageRightPeakTaxApplicationModel {
  fetchDataFromPeakAccount!: boolean;
}
export class MerchantPackageRightPeakAssetApplicationModel {
  totalAsset!: boolean;
}
